import { render, staticRenderFns } from "./picturePreview.vue?vue&type=template&id=2def87ca&scoped=true&"
import script from "./picturePreview.vue?vue&type=script&lang=js&"
export * from "./picturePreview.vue?vue&type=script&lang=js&"
import style0 from "./picturePreview.vue?vue&type=style&index=0&id=2def87ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def87ca",
  null
  
)

export default component.exports